export default "__VITE_ASSET__cb8c3b58__"